import React from 'react';
import PropTypes from 'prop-types';
import loadScript from 'load-script';

let loaded = false;

class UbeuLeadIdLoader extends React.Component {
    componentDidMount() {
        if (loaded) {
            return;
        }
        loadScript('https://create.lidstatic.com/campaign/bd597a6b-d61c-f244-7bc4-af1064bf76cd.js?snippet_version=2', () => {
            loaded = true;
        });
    }
    render() {
        return null;
    }
}

UbeuLeadIdLoader.propTypes = {
    onLoaded: PropTypes.func,
};

UbeuLeadIdLoader.defaultProps = {
    onLoaded: () => null,
};

export default UbeuLeadIdLoader;



// WEBPACK FOOTER //
// ./src/client/Components/UbeuLeadId/UbeuLeadIdScript.js